(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("8fV4r", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $971347e17232607f$export$b3890eb0ae9dca99; });

var $cg0NS = parcelRequire("cg0NS");

function $971347e17232607f$export$b3890eb0ae9dca99() {
    var splide = new (0, $cg0NS.default)(".splide", {
        perPage: 2.5,
        focus: 0,
        omitEnd: true,
        drag: "free",
        breakpoints: {
            640: {
                perPage: 1.2
            },
            720: {
                perPage: 1.6
            },
            1080: {
                perPage: 2.2
            }
        }
    });
    splide.mount();
}

});

})();
//# sourceMappingURL=information-block.c58d6965.js.map
